module.exports = __webpack_public_path__ + "static/media/image_6.6d99dbfc.png";